import { render, staticRenderFns } from "./MatchVideo.vue?vue&type=template&id=2502b074&"
import script from "./MatchVideo.vue?vue&type=script&lang=js&"
export * from "./MatchVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports